
import CategoryModule from "../views/ui/categoryModule/categoryModule";
import Menus from "../views/ui/menu/menu";
import Module from "../views/ui/module/module";
import TypeUdn from "../views/configuration/typeUdn/typeUdn";
import RequestMap from "../views/security/requestMap/requestMap";
import Role from "../views/security/role/role";
import RolePermission from "../views/security/rolePermission/rolePermission";
import Users from "../views/security/user/user";
import UserRole from "../views/security/userRole/userRole";
import ConfGlobal from "../views/configuration/confGlobal/confGlobal";
import Lang from "../views/configuration/lang/lang";
import Tag from "../views/clasificators/tag/tag";
import FirebaseRoleAccess from "../views/security/firebaseRoleAcces/firebaseRoleAccess";
import FbDatabase from "../views/firebase/fbDatabase/fbDatabase";
import FbChildPath from "../views/firebase/fbChildPath/fbChildPath";
import LogHistory from "../views/monitor/logHistory/logHistory";

import Employee from "../views/hr/employee/employee";
import Category from "../views/clasificators/category/category";
import Restriction from "../views/clasificators/restriction/restriction";
import FiltersMap from "../views/map/filtersMap/filtersMap";
import Departments from "../views/hr/department/departments";
import Season from "../views/atv/season/season";
import Schedule from "../views/atv/schedule/schedule";
import TypeSeason from "../views/clasificators/typeSeason/typeSeason";
import Label from "../views/configuration/label/label";
import FbProject from "../views/firebase/fbProject/fbProject";
import Legal from "../views/configuration/legal/legal";
import ServicesLocation from "../views/atv/servicesLocation/servicesLocation";
import Admission from "../views/core/admission/admission";
import ToDoTask from "../views/profile/toDoTask/toDoTask";
import ConfMaps from "../views/configuration/confMaps/confMap";
import CategoryProduct from "../views/promotions/categoryProduct/categoryProduct";
import TypeProduct from "../views/promotions/typeProduct/typeProduct";
import Currency from "../views/promotions/currency/currency";
import Benefit from "../views/promotions/benefit/benefit";
import TabOption from "../views/promotions/tabOption/tabOption";
import Promotion from "../views/promotions/promotion/promotion";
import Product from "../views/promotions/product/product";
import CategoryPromotion from "../views/promotions/categoryPromotion/categoryPromotion";
import Pickup from "../views/configuration/pickup/pickup";
import Addon from "../views/configuration/addon/addon";
import TypePlace from "../views/hotel/typePlace/typePlace";
import RoomType from "../views/hotel/roomType/RoomType";
import AmenityType from "../views/hotel/amenityType/AmenityType";
import Amenity from "../views/hotel/amenity/Amenity";
import Room from "../views/hotel/room/Room";
import WebCam from "../views/hotel/webcam/webCam";
import HotelCategory from "../views/hotel/category/HotelCategory";
import TypeContact from "../views/hotel/typeContact/typeContact";
import Contact from "../views/hotel/contact/contact";
import Airline from "../views/hotel/airline/Airline";
import Award from "../views/clasificators/award/Award";
import PhoneCode from "../views/hotel/phoneCode/PhoneCode";
import SalesPackage from "../views/promotions/salesPackage/salesPackage";
import Harbor from "../views/xailing/harbor/harbor";
import XailingRout from "../views/xailing/xailingRout/xailingRout";
import XwitchLog from "../views/monitor/xwitchLog/XwitchLog";
import HotelActivity from "../views/hotel/activity/Activity";
import PersonalTitle from "../views/hotel/personalTitle/PersonalTitle";
import AfiClass from "../views/hotel/afiClass/AfiClass";
import Destination from "../views/xailing/destination/Destination";
import TypeDestinationActivity from "../views/xailing/typeDestinationActivity/typeDestinationActivity";
import Faq from "../views/hotel/faq/Faq";
import XwitchDashboard from "../views/bi/xwitchDashboard/XwitchDashboard";
import ContactCategory from "../views/xailing/contacCategory/contacCategory";
import Chef from "../views/ayb/chef/Chef";
import AybCategory from "../views/ayb/category/AybCategory";
import AybMenu from "../views/ayb/menu/AybMenu";
import PhotoDashboard from "../views/bi/photoDashboard/PhotoDashboard";
import Vector from "../views/xeeker/vector/Vector";
import PathMap from "../views/xeeker/path/PathMap";
import AirTerminal from "../views/hotel/terminal/Terminal";
import Glossary from "../views/xooka/Glossary";
import XtorageFile from "../views/xtorage/file/XtorageFile";
import XtorageCategories from "../views/design/category/XtorageCategories";
import XtorageCampaigns from "../views/design/campaigns/XtorageCampaigns";
import XtorageTag from "../views/design/tag/XtorageTag";
import AybAttribute from "../views/ayb/attribute/Attribute";
import XpaCategory from "../views/xpa/xpaCategory/XpaCategory";
import XpaTreatment from "../views/xpa/xpaTreatments/XpaTreatments";
import Map3D from "../components/map3d/Map3D";
import TypeXpecial from "../views/todoFluye/typeXpecial/TypeXpecial";
import Wishlist from "../views/todoFluye/wishlist/Wishlist";
import Afi from "../views/hotel/afi/Afi";
import InHouseRequest from "../views/todoFluye/request/InHouseRequest";
import Program from "../views/atv/program/Program";
import BadWord from "../views/eventx/badwords/badWord";
import BusDate from "../views/eventx/busDate/busDate";
import BusPickup from "../views/eventx/busPickup/busPickup";
import BusRoute from "../views/eventx/busRoute/BusRoute";
import BusSchedule from "../views/eventx/busSchedule/busSchedule";
import TypeAudience from "../views/eventx/typeAudience/TypeAudience";
import MapConfig from "../views/map/mapConfig/MapConfig";
import TypeRestriction from "../views/todoFluye/typeRestrictions/TypeRestriction";
import Campaign from "../views/comunication/campaign/Campaign";
import Applicative from "../views/firebase/Applicative/Applicative";
import Itinerary from "../views/eventx/itinerary/Itinerary";
import Activity from "../views/core/activity/Activity";
import Trace from "../views/map/trace/Trace";
import EasyPath from "../views/map/easyPath/EasyPath";
import Notification from "../views/comunication/notification/Notification";
import PromotionController from "../views/promotions/promotionController/PromotionController";
import AppRequestLog from "../views/monitor/AppRequestLog/AppRequestLog";
import AppRequestLogDashboard from "../views/monitor/AppRequestLogDashboard/AppRequestLogDashboard";
import ComponentCatalog from "../views/develop/componentCatalog/ComponentCatalog";
import Airport from "../views/hotel/airport/Airport";
import LabelGeneral from "../views/configuration/label/labelGeneral";
import LangGeneral from "../views/configuration/lang/langGeneral";
import Pax from "../views/clasificators/pax/Pax";
import RestaurantController from "../views/ayb/restaurantController/RestaurantController";
import WishlistSalesforce from "../views/todoFluye/wishlistSalesforce/WishlistSalesforce";
import EventController from "../views/core/eventController/EventController";
import Place from "../views/core/place/Place";
import ParamSettings from "../views/configuration/paramSettings/paramSettings";
import ParamSettingsGeneral from "../views/configuration/paramSettings/paramSettingsGeneral";
import HomeController from "../views/hotel/homeController/HomeController";
import XpaController from "../views/hotel/controllers/XpaController";
import XtoreController from "../views/hotel/controllers/XtoreController";
import HousesController from "../views/hotel/controllers/HousesController";
import FbMediaConfig from "../views/firebase/fbMediaConfig/FbMediaConfig";
import TranslateStatistics from "../views/xooka/metrics/TrsanslateStatistics";
import Services from "../views/core/services/Services";
import UdnGeneral from "../views/core/udn/UdnGeneral";
import UdnApp from "../views/core/udn/UdnApp";
import UdnAppCat from "../views/core/udn/UdnAppCat";
import JobHistory from "../views/configuration/jobHistory/JobHistory";
import SuiteController from "../views/hotel/suiteController/SuiteController";
import ModuleController from "../views/ui/moduleController/ModuleController";
import TypeServices from "../views/clasificators/typeServices/TypeServices";
import InHouseController from "../views/hotel/controllers/InHouseController";
import Page from "../views/landings/page/Page";
import Section from "../views/landings/section/Section";
import Widget from "../views/landings/widget/Widget";
import Icon from "../views/landings/icon/Icon";
import TranslateCount from "../views/xooka/translateCount/TranslateCount";
import DailyTranslationCount from "../views/xooka/dailyTranslationCount/DailyTranslationCount";
import EntretainmentController from "../views/hotel/controllers/EntrController";
import PaymentMethod from "../views/configuration/paymentMethod/PaymentMethod";
import ClassConfiguration from "../views/configuration/classConfiguration/ClassConfiguration";
import PlaceServices from "../views/core/placeServices/PlaceServices";
import PromotionActivity from "../views/promotions/activity/PromotionActivity";
import Allotment from "../views/promotions/restaurant/Allotment";
import LogHistoryDashboard from "../views/monitor/LogHistoryDashboard/LogHistoryDashboard";
import DishDrink from "../views/ayb/dishDrink/DishDrink";
import DynamicModules from "../views/park/dynamicModules/DynamicModules";
import QueryExecutor from "../views/security/executorQuery/queryExecutor";
import Rout from "../views/clasificators/rout_v2/rout";


let componentsSidebar = {
// test push
    "/general/label": {comp: LabelGeneral, breadcrumb: "/Configuración/Etiquetas"},
    "/general/paramSettings": {comp: ParamSettingsGeneral, breadcrumb: "/Configuración/Parametros de configuración"},
    "/general/lang": {comp: LangGeneral, breadcrumb: "/Configuración/Idiomas"},

    "/core/udn"         : {comp: UdnGeneral, breadcrumb: ""},
    "/core/activity"    : {comp: Activity, breadcrumb: "Actividades"},
    "/core/place"       : {comp: Place, breadcrumb: "Lugares"},
    "/core/services"    : {comp: Services, breadcrumb: "Servicios"},
    "/core/restaurants" : {comp: RestaurantController, breadcrumb: "Restaurantes"},

    "/catalogs/udn": {comp: UdnAppCat, breadcrumb: "/Catalogos/Unidad de Negocio"},
    "/configuration/udn": {comp: UdnApp, breadcrumb: "/Configuracón/Unidad de Negocio"},

    "/ui/tree": {comp: ModuleController, breadcrumb: "/UI/Modulos"},
    "/ui/components": {comp: ComponentCatalog, breadcrumb: "/ui/components"},
    "/configuration/categoryModule": {comp: CategoryModule, breadcrumb: "/Configuracón/Categorías de Módulos"},
    "/configuration/menu": {comp: Menus, breadcrumb: "/Configuracón/Menus"},
    "/configuration/module": {comp: Module, breadcrumb: "/Configuracón/Módulos"},
    "/configuration/typeUdn": {comp: TypeUdn, breadcrumb: "/Configuracón/Tipos de Unidad de Negocio"},
    "/configuration/globalConfig": {comp: ConfGlobal, breadcrumb: "/Configuración/Conexiones"},
    "/configuration/mapsConfig": {comp: ConfMaps, breadcrumb: "/Configuración/Mapas"},
    "/configuration/label": {comp: Label, breadcrumb: "/Configuración/Etiquetas"},
    "/configuration/legal": {comp: Legal, breadcrumb: "/Configuración/Legales"},
    "/configuration/lang": {comp: Lang, breadcrumb: "/Configuración/Idiomas"},
    "/configuration/admission": {comp: Admission, breadcrumb: "/Configuración/Entradas"},
    "/configuration/pickup": {comp: Pickup, breadcrumb: "/Configuración/Pickup"},
    "/configuration/addon": {comp: Addon, breadcrumb: "/Configuración/Addon"},
    "/configuration/paramSettings": {comp: ParamSettings, breadcrumb: "/Configuración/Parametros de configuración"},

    "/security/requestMap": {comp: RequestMap, breadcrumb: "/Seguridad/Permisos Url"},
    "/security/role": {comp: Role, breadcrumb: "/Seguridad/Roles"},
    "/security/firebaseRoleAccess": {comp: FirebaseRoleAccess, breadcrumb: "/Seguridad/Rol Permiso Firebase"},
    "/security/rolePermission": {comp: RolePermission, breadcrumb: "/Seguridad/Permisos UI"},
    "/security/user": {comp: Users, breadcrumb: "/Seguridad/Usuarios"},
    "/security/userRole": {comp: UserRole, breadcrumb: "/Seguridad/Usuario Rol"},
    "/security/logHistory":{ comp:LogHistory , breadcrumb: "/Seguridad/Logs del Sistema"} ,
    "/security/xwitchLog":{ comp:XwitchLog , breadcrumb: "/Seguridad/Log de Xwitch"} ,

    "/security/xwitchDashboard":{ comp:XwitchDashboard , breadcrumb: "/Seguridad/Dashboard Xwitch"} ,
    "/security/executeQuery":{ comp:QueryExecutor , breadcrumb: "/Seguridad/Ejecutor de querys"} ,

    "/bi/xwitchDashboard":{ comp:XwitchDashboard , breadcrumb: "/Analiticos/Dashboard Xwitch"} ,
    "/bi/photoDashboard":{ comp:PhotoDashboard , breadcrumb: "/Analiticos/Dashboard Photo"} ,

    "/xeeker/point":{ comp:Map3D , breadcrumb: "/Mapa/Puntos"} ,
    "/xeeker/vector":{ comp:Vector , breadcrumb: "/Mapa/Vectores"} ,
    "/xeeker/path":{ comp:PathMap , breadcrumb: "/Mapa/Caminos"} ,

    // MAPAS
    "/map/configuration"    : { comp:MapConfig  , breadcrumb: "/Mapa/Configuración General"} ,
    "/map/filters"          : { comp:FiltersMap , breadcrumb: "/Mapa/Filtros"} ,
    "/map/trace"            : { comp:Trace      , breadcrumb: "/Mapa/Caminos"} ,
    "/map/easyPath"         : { comp:EasyPath   , breadcrumb: "/Mapa/Como llegar?"} ,

    "/clasificator/rout":{ comp:Rout , breadcrumb: "/Clasificadores/Rutas"} ,
    "/clasificator/category":{ comp:Category , breadcrumb: "/Clasificadores/Categorias"} ,
    "/clasificator/lang":{ comp:Lang , breadcrumb: "/Clasificadores/Lenguajes"},
    "/clasificator/tag":{ comp:Tag , breadcrumb: "/Clasificadores/Tags"},
    "/clasificator/filtersMap":{ comp:FiltersMap , breadcrumb: "/Clasificadores/Filtros de Mapa"},
    "/clasificator/awards":{ comp:Award , breadcrumb: "/Clasificadores/Premios"},
    "/clasificator/restriction":{ comp:Restriction , breadcrumb: "/Clasificadores/Restricciones"},
    "/clasificator/services":{ comp:TypeServices , breadcrumb: "/Clasificadores/Tipos Servicios"},
    "/clasificator/typeSeason":{ comp:TypeSeason , breadcrumb: "/Clasificadores/Tipos Temporadas"},

    "/config/applicative":{ comp:Applicative , breadcrumb: "/Configuración/Aplicaciones"},
    "/firebase/fbProject":{ comp:FbProject , breadcrumb: "/Firebase/Proyecto"},
    "/firebase/fbDataBase":{ comp:FbDatabase , breadcrumb: "/Firebase/Bases de Datos"},
    "/firebase/fbChildPath":{ comp:FbChildPath , breadcrumb: "/Firebase/Rutas"},
    "/firebase/fbMediaConfig": {comp: FbMediaConfig, breadcrumb: "/Firebase/Media"},

    "/hr/department":{ comp:Departments , breadcrumb: "/Recursos Humanos/Departamentos"},
    "/hr/employee":{ comp:Employee , breadcrumb: "/Recursos Humanos/Colaboradores"},

    "/atv/activity": {comp: Activity, breadcrumb: "ATV/Actividades"},
    "/atv/season": {comp: Season, breadcrumb: "ATV/Temporadas"},
    "/atv/schedule": {comp: Schedule, breadcrumb: "ATV/Horarios"},
    "/atv/location": {comp: ServicesLocation, breadcrumb: "/ATV/Ubicaciones de servicios"},
    "/atv/program": {comp: Program, breadcrumb: "ATV/Programas"},

    "/profile/todotask": {comp: ToDoTask, breadcrumb: "Perfil/Notificaciones"},

    // VENTA IN-APP
    "/sales/promotionController"     : {comp: PromotionController, breadcrumb: "Promociones"},
    "/promo/catProduct"     : {comp: CategoryProduct, breadcrumb: "Promociones/Categoría de producto"},
    "/promo/typeProduct"    : {comp: TypeProduct, breadcrumb: "Promociones/Tipos de producto"},
    "/promo/currency"       : {comp: Currency, breadcrumb: ""},
    "/promo/benefits"       : {comp: Benefit, breadcrumb: "Promociones/Beneficios"},
    "/promo/tabOption"      : {comp: TabOption, breadcrumb: "Promociones/Tabs"},
    "/promo/promotion"      : {comp: Promotion, breadcrumb: "Promociones"},
    "/promo/product"        : {comp: Product, breadcrumb: "Productos"},
    "/promo/package"        : {comp: SalesPackage, breadcrumb: "Paquetes"},
    "/promo/catPromotion"   : {comp: CategoryPromotion, breadcrumb: "Promociones/Categoría de Promoción"},

    "/hotel/home"           : {comp: HomeController, breadcrumb: "Hotel/Home"},
    "/hotel/xpa"            : {comp: XpaController, breadcrumb: "Armonia"},
    "/hotel/xtore"          : {comp: XtoreController, breadcrumb: "Tiendas"},
    "/hotel/houses"         : {comp: HousesController, breadcrumb: "Casas"},
    "/hotel/suites"         : {comp: SuiteController, breadcrumb: "Habitaciones"},
    "/hotel/inhouse"          : {comp: InHouseController, breadcrumb: "Interior de la casa"},
    "/hotel/entretainment"          : {comp: EntretainmentController, breadcrumb: "Hotel/Entretenimiento"},

    "/hotel/category"       : {comp: HotelCategory, breadcrumb: "Hotel/Categorías"},
    "/hotel/afiClass"       : {comp: AfiClass, breadcrumb: "Hotel/Categorías All Fun Inclusive"},
    "/hotel/allFunInclusive"       : {comp: Afi, breadcrumb: "Hotel/All Fun Inclusive"},
    "/hotel/place"          : {comp: Place, breadcrumb: "Hotel/Lugares"},
    "/hotel/services"          : {comp: PlaceServices, breadcrumb: "Hotel/Servicios"},
    "/hotel/typePlace"      : {comp: TypePlace, breadcrumb: "Hotel/Tipos de lugar"},
    "/hotel/typeRoom"       : {comp: RoomType, breadcrumb: "Hotel/Tipos de cuarto"},
    "/hotel/typeAmenity"    : {comp: AmenityType, breadcrumb: "Hotel/Tipos de amenidad"},
    "/hotel/amenity"        : {comp: Amenity, breadcrumb: "Hotel/Amenidad"},
    "/hotel/room"           : {comp: Room, breadcrumb: "Hotel/Cuartos"},
    "/hotel/webcam"         : {comp: WebCam, breadcrumb: "Hotel/WebCam"},
    "/hotel/typeContact"    : {comp: TypeContact, breadcrumb: "Hotel/Type Contact"},
    "/hotel/contact"        : {comp: Contact, breadcrumb: "Hotel/Contact"},
    "/hotel/airline"        : {comp: Airline, breadcrumb: "Hotel/Airline"},
    "/hotel/phoneCode"      : {comp: PhoneCode, breadcrumb: "Hotel/PhoneCode"},
    "/hotel/activity"       : {comp: HotelActivity, breadcrumb: "Hotel/Activity"},
    "/hotel/personalTitle"  : {comp: PersonalTitle, breadcrumb: "Hotel/PersonalTitle"},
    "/hotel/airport"        : {comp: Airport, breadcrumb: "Hotel/Aeropuerto"},
    "/hotel/terminal"       : {comp: AirTerminal, breadcrumb: "Hotel/Terminal"},
    "/hotel/faqs"           : {comp: Faq, breadcrumb: "Hotel/Faqs"},
    "/hotel/typeXpecial"    : {comp: TypeXpecial, breadcrumb: "/hotel/typeXpecial"},
    "/hotel/typeRestriction": {comp: TypeRestriction, breadcrumb: "/hotel/typeRestriction"},
    "/hotel/wishlist"       : {comp: Wishlist, breadcrumb: "/hotel/wishlist"},
    "/wishlist/salesforce": {comp: WishlistSalesforce, breadcrumb: "/wishlist/salesforce"},
    "/hotel/inHouseRequest" : {comp: InHouseRequest, breadcrumb: "/hotel/inHouseRequest"},

    "/xailing/category"     : {comp: ContactCategory, breadcrumb: "Naviera/Categorías"},
    "/xailing/harbor"       : {comp: Harbor, breadcrumb: "Naviera/Puertos"},
    "/xailing/xailingRout"  : {comp: XailingRout, breadcrumb: "Naviera/Rutas"},
    "/xailing/destination"  : {comp: Destination, breadcrumb: "Naviera/Destinos"},
    "/xailing/typeActivity" : {comp: TypeDestinationActivity, breadcrumb: "Naviera/Tipós de Actividades"},

    "/ayb/chef"             : {comp: Chef, breadcrumb: "A&B/Chef"},
    "/ayb/category"         : {comp: AybCategory, breadcrumb: "A&B/Categorias"},
    "/ayb/menu"             : {comp: AybMenu, breadcrumb: "A&B/Menu"},
    "/ayb/aybAttribute"     : {comp: AybAttribute, breadcrumb: "A&B/Atributos"},
    "/ayb/dishDrink"        : {comp: DishDrink, breadcrumb: "A&B/Platillos y Bebidas"},


    // "/hotel/xpa"     : {comp: ComponentCatalog, breadcrumb: "Spas"},
    "/xpa/category"     : {comp: XpaCategory, breadcrumb: "Categorias"},
    "/xpa/treatment"     : {comp: XpaTreatment, breadcrumb: "Tratamientos"},

    // TRANSLATION
    "/xeeker/glossary"      : {comp: Glossary, breadcrumb: "xeeker/Glossary"},
    "/xeeker/translateCount"      : {comp: TranslateCount, breadcrumb: "xeeker/translateCount"},

    "/xtorage/file"      : {comp: XtorageFile, breadcrumb: "/xtorage/file"},
    "/design/category"      : {comp: XtorageCategories, breadcrumb: "/design/category"},
    "/design/campaigns"      : {comp: XtorageCampaigns, breadcrumb: "/design/campaigns"},
    "/design/tag"      : {comp: XtorageTag, breadcrumb: "/design/tag"},


    "/core/events"           : {comp: EventController, breadcrumb: ""},
    "/events/eventos"           : {comp: EventController, breadcrumb: ""},
    "/events/itinerary"         : {comp: Itinerary, breadcrumb: ""},
    "/events/badwords"          : {comp: BadWord, breadcrumb: ""},
    "/events/typeAudience"      : {comp: TypeAudience, breadcrumb: ""},
    "/events/typeServices"      : {comp: TypeServices, breadcrumb: ""},
    "/bus/dates"                : {comp: BusDate, breadcrumb: ""},
    "/bus/pickups"              : {comp: BusPickup, breadcrumb: ""},
    "/bus/routes"               : {comp: BusRoute, breadcrumb: ""},
    "/bus/schedules"            : {comp: BusSchedule, breadcrumb: ""},
    "/events/genre"             : {comp: Category, breadcrumb: ""},
    "/events/maps"              : {comp: MapConfig, breadcrumb: ""},
    "/hotel/maps"               : {comp: MapConfig, breadcrumb: ""},
    "/configuration/maps"       : {comp: MapConfig, breadcrumb: ""},
    "/events/servicesLocations" : {comp: ServicesLocation, breadcrumb: ""},
    "/events/contacts"          : {comp: Contact, breadcrumb: ""},
    "/events/place"             : {comp: Place, breadcrumb: ""},
    "/events/activities"        : {comp: Activity, breadcrumb: ""},
    "/events/pax"               : {comp: Pax, breadcrumb: ""},

    "/events/catalogs/legal"         : {comp: Legal, breadcrumb: ""},
    "/ferries/configuration/legal"         : {comp: Legal, breadcrumb: ""},
    "/hoteles/configuration/legal"         : {comp: Legal, breadcrumb: ""},

    // COMUNICACIÓN
    "/comunication/campaign"      : {comp: Campaign, breadcrumb: "/comunication/campaign"},
    "/park/cat/campaign"      : {comp: Campaign, breadcrumb: "/park/cat/campaign"},
    "/park/dynamic/modules"      : {comp: DynamicModules, breadcrumb: "/park/dynamic/modules"},

    "/xailing/notification" : {comp: Notification, breadcrumb: "notification"},
    "/hotel/notification" : {comp: Notification, breadcrumb: "notification"},
    "/park/notification" : {comp: Notification, breadcrumb: "notification"},

    // MONITOREO
    "/monitor/logHistory" : {comp: LogHistory, breadcrumb: "logHistory"},
    "/monitor/logHistoryDashboard" : {comp: LogHistoryDashboard, breadcrumb: "logHistoryDashboard"},
    "/monitor/xwitchLog" : {comp: XwitchLog, breadcrumb: "xwitchLog"},
    "/monitor/appRequestLog" : {comp: AppRequestLog, breadcrumb: "appRequestLog"},
    "/monitor/appRequestDashboard" : {comp: AppRequestLogDashboard, breadcrumb: "appRequestDashboard"},
    "/monitor/jobHistory" : {comp: JobHistory, breadcrumb: "JobHistory"},

    // MÉTRICAS DE TRADUCCIÓN
    "/monitor/translate" : {comp: TranslateStatistics, breadcrumb: "Métricas de Traducción"},
    "/monitor/dailyTranslationCount" : {comp: DailyTranslationCount, breadcrumb: "Conteo de traducción diaria"},

    // LANDINGS
    "/landing/page" : {comp: Page, breadcrumb: "/landing/paginas"},
    "/landing/section" : {comp: Section, breadcrumb: "/landing/secciones"},
    "/landing/widget" : {comp: Widget, breadcrumb: "/landing/widget"},
    "/landing/icon" : {comp: Icon, breadcrumb: "/landing/icon"},


    // CONFIGURATION
    "/configuration/paymentMethod" : {comp: PaymentMethod, breadcrumb: "/configuration/paymentMethod"},

    "/configuration/class": {comp: ClassConfiguration, breadcrumb: "/configuración/clases"},


    //CONSUMO INTERNO
    "/promo/promotionActivity": {comp: PromotionActivity, breadcrumb: "/promo/promotionActivity"},
    "/allotment/restaurant": {comp: Allotment, breadcrumb: "/allotment/restaurant"},

};

export default componentsSidebar;